import { Box, Typography } from "@material-ui/core";
import React, { Fragment } from "react";
import {
    DateInput,
    email,
    maxLength,
    minLength,
    required,
    TextInput,
} from "react-admin";

const PersonalDetails = () => {
    return (
        <Fragment>
            <Typography variant="h6" gutterBottom>
                Personal Details
            </Typography>

            <TextInput
                type="email"
                source="email"
                resource="users"
                validate={[email(), required()]}
                fullWidth
            />

            <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <TextInput
                        source="preferedName"
                        resource="users"
                        validate={requiredValidate}
                        fullWidth
                    />
                </Box>

                <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                    <TextInput
                        source="name"
                        resource="users"
                        validate={requiredValidate}
                        fullWidth
                    />
                </Box>
            </Box>

            <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                    <DateInput
                        source="birthDate"
                        resource="users"
                        fullWidth
                        helperText={false}
                    />
                </Box>

                <Box flex={1} ml={{ xs: 0, sm: "0.5em" }}>
                    <TextInput
                        source="contact"
                        label="Emergency Contact"
                        resource="users"
                        fullWidth
                        helperText={false}
                        type="number"
                        validate={[maxLength(10), minLength(10)]}
                    />
                </Box>
            </Box>
        </Fragment>
    );
};

const requiredValidate = [required()];

export default PersonalDetails;
